import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FechamentoFinanceiroService } from '../../services/fechamento-financeiro.service';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { PedidoFechamento } from '../../models/pedido-fechamento';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-pedidos-fechamento',
  templateUrl: './pedidos-fechamento.component.html',
  styleUrls: ['./pedidos-fechamento.component.scss']
})
export class PedidosFechamentoComponent implements OnInit {
  idFechamento: number;
  pedidos: PedidoFechamento[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<void>,
    @Inject(MAT_DIALOG_DATA) public data: {idFechamento: number},
    private fechamentoFinanceiroService: FechamentoFinanceiroService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService
  ) {
    this.idFechamento = data.idFechamento;
  }

  ngOnInit(): void {
    this.buscarPedidosDoFechamento();
  }

  buscarPedidosDoFechamento() {
    this.carregandoService.mostra('buscarPedidosDoFechamento');

    this.fechamentoFinanceiroService.consultarPedidosDoFechamento(this.idFechamento).subscribe(
      (pedidos: PedidoFechamento[]) => {
        this.pedidos = pedidos;
        this.carregandoService.esconde('buscarPedidosDoFechamento');
      },
      (err: Error) => {
        this.carregandoService.esconde('buscarPedidosDoFechamento');
        this.notificacaoService.erro(err);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

}
